<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>Documenti Trasporto</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="showFilter">
              <v-icon color="purple"> mdi-filter</v-icon>
            </v-btn>
          </template>
          <span>Filtri</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="$router.push('/home/production')"
            >
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>

      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>

      <v-row v-if="filterVisible">
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-text-field label="Filtro" class="ma-1" outlined dense>
          </v-text-field>
        </v-col>
      </v-row>

      <v-card-text>
        <v-data-table
          :items="filterVisible ? filtered : listDDT"
          :headers="headers"
          :page.sync="pageNumber"
        >
          <template v-slot:[`item.dettaglio`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  elevation="1"
                  class="mr-3"
                  @click="openDdt(item)"
                >
                  <v-icon color="#1a80b6"> mdi-eye </v-icon>
                </v-btn>
              </template>
              <span>Dettaglio DDT</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.stato_doc`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon :color="stateIcons[item.stato_doc].color" v-on="on">
                  {{ stateIcons[item.stato_doc].icon }}
                </v-icon>
              </template>
              <span>{{ stateIcons[item.stato_doc].desc }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "DDT",
  components: {
    SnackbarQV,
  },
  data() {
    return {
      pageNumber: 1,
      loading: false,
      filterVisible: false,
      listDDT: [],
      filtered: [],
      stateIcons: [
        {
          color: "error",
          icon: "mdi-cancel",
          desc: "Nessun ubicazione confermato",
        },
        {
          color: "yellow accent-4",
          icon: "mdi-information",
          desc: "Ubicazioni parzialmente confermati",
        },
        {
          color: "success",
          icon: "mdi-check",
          desc: "Ubicazioni completatmente confermati",
        },
      ],
      headers: [
        {
          text: "Dettaglio",
          value: "dettaglio",
        },
        {
          text: "Codice",
          value: "num_documento",
        },
        {
          text: "Data",
          value: "data_documento",
        },
        {
          text: "Stato",
          value: "stato_doc",
        },
      ],
    };
  },
  mounted() {
    this.inizializza();
  },
  methods: {
    openDdt(item) {
      localStorage.setItem("ddt_page", this.pageNumber.toString());
      this.$router.push({
        name: "DDTDettaglio",
        params: {
          num_ddt: item.num_documento,
          id_ddt: item.id_documento,
        },
      });
    },
    async inizializza() {
      this.loading = true;

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdocumento",
          token: localStorage.user_token,
          id_documento: "%",
          cod_documento: "DDT",
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.listDDT = Array.from(res.data.documento);
            this.filtered = Array.from(res.data.documento);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricar ei dati."
            );
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        });

      if (localStorage.getItem("ddt_page") != "null")
        this.pageNumber = parseInt(localStorage.getItem("ddt_page"));
    },
    showFilter() {
      this.filterVisible = !this.filterVisible;
    },
  },
};
</script>